<template>
<div id="header">
    <v-navigation-drawer :clipped="drawer.clipped" :fixed="drawer.fixed" :permanent="drawer.permanent" :mini-variant="drawer.mini" v-model="drawer.open" app temporary >
	<v-list>
<!--
	    <v-list-tile v-if="!drawer.permanent" @click="makeDrawerPermanent">
		<v-list-tile-action><v-icon>chevron_right</v-icon></v-list-tile-action>
		<v-list-tile-content>
			<v-list-tile-title>Static Drawer</v-list-tile-title>
		</v-list-tile-content>
	    </v-list-tile>
	    <v-list-tile @click="toggleMiniDrawer">
		<v-list-tile-action><v-icon>aspect_ratio</v-icon></v-list-tile-action>
		<v-list-tile-content><v-list-tile-title>Mini Drawer</v-list-tile-title></v-list-tile-content>
	    </v-list-tile>

	    <v-divider></v-divider>

	    <v-list-tile @click="">
		    <v-list-tile-action><v-icon>dashboard</v-icon></v-list-tile-action>
		    <v-list-tile-content> <v-list-tile-title>Dashboard</v-list-tile-title> </v-list-tile-content>
	    </v-list-tile>
-->
<!-- https://material.io/tools/icons/ -->
	    <v-list-tile to="/">
	      <v-list-tile-action><v-icon>fas fa-compass</v-icon></v-list-tile-action>
	      <div>My TapTags</div>
  	    </v-list-tile>
	    <v-divider></v-divider>
	    <v-list-tile to="/profile/login" v-if="!authenticated">
		<v-list-tile-action><v-icon>person</v-icon></v-list-tile-action>
	      <span class="mr-2">Login</span>
  	    </v-list-tile>
	    <v-list-tile to="/profile/register" v-if="!authenticated">
		<v-list-tile-action><v-icon>person_add</v-icon></v-list-tile-action>
	      <span class="mr-2">Register</span>
  	    </v-list-tile>
            <v-list-tile v-if="authenticated && !myprofile.qualified_profile" to="/">
		<v-list-tile-action><v-icon>settings</v-icon></v-list-tile-action>
                Account Setup
            </v-list-tile>

	    <v-list-tile v-if="qualified" to="/events">
		<v-list-tile-action><v-icon>map</v-icon></v-list-tile-action>
		All Events
	    </v-list-tile>
	    <v-divider></v-divider>
	    <v-divider></v-divider>
	    <v-list-tile v-for="attendee in attendees" :to="`/events/${attendee.event_id}`" :key="attendee.id" v-if="myprofile.qualified_profile">
		<v-list-tile-action><v-icon>flight_takeoff</v-icon></v-list-tile-action>
		{{eventTitle(attendee)}}
	    </v-list-tile>

	    <v-divider></v-divider>

	    <v-list-tile v-if="qualified" to="/profile">
		<v-list-tile-action><v-icon>person</v-icon></v-list-tile-action>
                Check-In Identification
	    </v-list-tile>
	    <v-list-tile to="/profile/password" v-if="qualified">
		<v-list-tile-action><v-icon>settings</v-icon></v-list-tile-action>
	      <span class="mr-2">Change Password</span>
  	    </v-list-tile>
	    <v-divider></v-divider>
	    <v-list-tile to="/about">
	      <span class="mr-2">About</span>
  	    </v-list-tile>
	    <v-divider></v-divider>
	    <v-list-tile @click="logout" v-if="authenticated">
		<v-list-tile-action><v-icon>power_settings_new</v-icon></v-list-tile-action>
	      <span class="mr-2">Logout</span>
  	    </v-list-tile>
	</v-list>
    </v-navigation-drawer>

<!--https://vuetifyjs.com/en/framework/display-->
    <v-toolbar app :fixed="toolbar.fixed" :clipped-left="toolbar.clippedLeft" >
    <v-toolbar-side-icon @click.stop="toggleDrawer" ></v-toolbar-side-icon>

      <v-btn flat class="hidden-md-and-up" v-if="event" :to="`/events/${event.id}`" >
            <v-icon>home</v-icon> &nbsp; {{event.title}}
            <!--
            &nbsp;
            <span v-if="!authenticated">(Logged Out)</span>
            <span v-if="authenticated">(Logged In)</span>
            -->
      </v-btn>

      <v-btn flat class="hidden-md-and-up" v-if="!event" :to="`/`" >
        Mobile TapTags 
        <span v-if="!authenticated">(Logged Out)</span>
        <span v-if="authenticated">(Logged In)</span>
      </v-btn>


      <v-toolbar-title class="headline text-uppercase hidden-sm-and-down">
	  <v-btn flat to="/">
	    <span class="mr-2">My TapTags</span>
	  </v-btn>

        <v-btn flat class="font-weight-light" :to="`/events/${event.id}`" v-if="event">
            <span class="mr-2">{{event.title}}</span>
        </v-btn>
      </v-toolbar-title>



      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn to="/profile" v-if="qualified">Profile</v-btn>
        <v-btn to="/events" v-if="qualified">Events</v-btn> 
	  <v-btn flat to="/profile/login" v-if="!authenticated">
	    <span class="mr-2">Login</span>
	  </v-btn>
	  <v-btn flat to="/profile/register" v-if="!authenticated">
	    <span class="mr-2">Register</span>
	  </v-btn>
	  <v-btn flat to="/about">
	    <span class="mr-2">About</span>
	  </v-btn>
      </v-toolbar-items>
    </v-toolbar>
</div>

</template>

<script>
import {mapState} from 'vuex';

export default {
  props: ['auth', 'authenticated'],
  name: 'Header',
  data: () => ({
    drawer: {
      // sets the open status of the drawer
      open: false,
      // sets if the drawer is shown above (false) or below (true) the toolbar
      clipped: false,
      // sets if the drawer is CSS positioned as 'fixed'
      fixed: false,
      // sets if the drawer remains visible all the time (true) or not (false)
      permanent: false,
      // sets the drawer to the mini variant, showing only icons, of itself (true)
      // or showing the full drawer (false)
      mini: false,
    },
    toolbar: {
      //
      fixed: true,
      // sets if the toolbar contents is leaving space for drawer (false) or not (true)
      clippedLeft: false,
    },
    footer: {
      // sets the CSS position of the footer
      fixed: true,
      // sets if the footer is full width (true) or gives space to the drawer (false)
      clippedLeft: true,
    },
  }),
  beforeMount: async function() {
    if (this.authenticated && this.myprofile.qualified_profile) {
      await this.$store.dispatch('loadEvents');
      await this.$store.dispatch('loadAttendees');
    }
  },
  computed: {
    ...mapState(['myprofile', 'events', 'attendees']),
    qualified() {
      return this.authenticated && this.myprofile.qualified_profile;
    },
    event() {
      return (this.$data.event = this.events?.find(x => {
        return x.id == this.$route.params.event_id;
      }));
    },
  },
  methods: {
    eventTitle(attendee) {
      let event = this.events?.find(x => {
        return x.id == attendee.event_id;
      });
      if (!!event) {
        return event.title;
      } else {
        return 'No Event Title';
      }
    },
    // changes the drawer to permanent
    makeDrawerPermanent() {
      this.drawer.permanent = true;
      // set the clipped state of the drawer and toolbar
      this.drawer.clipped = false;
      this.toolbar.clippedLeft = false;
    },
    // toggles the drawer variant (mini/full)
    toggleMiniDrawer() {
      this.drawer.mini = !this.drawer.mini;
    },
    // toggles the drawer type (permanent vs temporary) or shows/hides the drawer
    toggleDrawer() {
      if (this.drawer.permanent) {
        this.drawer.permanent = !this.drawer.permanent;
        // set the clipped state of the drawer and toolbar
        this.drawer.clipped = true;
        this.toolbar.clippedLeft = true;
      } else {
        // normal drawer
        this.drawer.open = !this.drawer.open;
      }
    },
    logout: async function() {
      await this.auth.logout();
      this.$store.dispatch('cleanHouse');
    },
  },
};
</script>
